import axios from "axios";
import LocalstorageService from "./localstorage.service";
import ResourceUrlUtil from "../utils/resource-url.util";

const http = () => {
  let lang = LocalstorageService.get("lang");
  if(!lang)
  {
    lang = "en";
    LocalstorageService.set("lang", lang);
  }
  let headers = {
    "Content-type": "application/json",
    "lang": lang
  };

  const instance = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
    headers: headers,
  });

  instance.interceptors.response.use((response) => {
    response.data = ResourceUrlUtil.sanitizeResourceUrls(response.data);
    return response;
  });

  return instance;
};

export default { http };
